module.exports = __webpack_public_path__ + "static/media/2 lunch.0444cab8.png";